import isEmpty from 'is-empty';
import {
  UPDATE_KYC,
  SET_UPDATE_KYC_ERROR,
  DELETE_UPDATE_KYC_ERROR,
  KYC_IS_LOADING
} from '../../actions/types';

const initialState = {
  success: false,
  error: '',
  kyc: {},
  kycLoading: false
};

const kyc = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_KYC:
      return {
        ...state,
        success: !isEmpty(action.kyc),
        kyc: action.kyc,
        kycLoading: false
      };
    case SET_UPDATE_KYC_ERROR:
      return {
        ...state,
        success: false,
        kyc: {},
        error: action.error,
        kycLoading: false
      };
    case DELETE_UPDATE_KYC_ERROR:
      return {
        error: ''
      };
    case KYC_IS_LOADING:
      return {
        kycLoading: true,
      };
    default: return state;
  }
};

export default kyc;
